<div class="container" [hidden]="useMatFormField || !startDate || !endDate" (clickOutside)="hidePanel()" [class.show-inline]="showInline">
	<div class="button" (click)="togglePanel()" *ngIf="!showInline">
		<i [hidden]="!icon" class="fa fa-{{icon}}"></i>
		<span *ngIf="time">
			{{ startDate | bbDate:'date-time' }} - 
			{{ endDate | bbDate:'date-time' }}
		</span>
		<span *ngIf="!time">
			{{ startDate | bbDate:'date' }} - 
			{{ endDate | bbDate:'date' }}
		</span>
	</div>
	
	<div [hidden]="!expanded && !showInline" [ngClass]="theme" class="panel {{ isLoading ? 'disabled' : '' }}">

		<bb-loading *ngIf="isLoading"></bb-loading>

		<ng-content select="[header]"></ng-content>

		<h3 class="preset-title">{{ 'DATE_RANGE' | translate }} <bb-info icon="warning" *ngIf="timeZoneMismatch" [contents]="'Your time-zone ('+ localTimeZoneName +') is different from the one used in the publication settings. Dates will use the publication timezone ('+ pubTimeZoneName +').'"></bb-info></h3>

		<bb-select class="preset-select" [options]="presets" [theme]="theme" [(ngModel)]="preset" (ngModelChange)="presetChanged()"></bb-select>

		<bb-floating-label class="analytics-select" [label]="'preset'" [active]="preset && preset !== 'custom'">
			<bb-select [options]="presets" [theme]="theme" [(ngModel)]="preset" (ngModelChange)="presetChanged()"></bb-select>
		</bb-floating-label>

		<div class="dates">
			<div class="date">
				<label>{{ 'START_DATE' | translate }}</label>

				<bb-warning *ngIf="minDateWarning" [hidden]="!datesCorrected" [contents]="minDateWarning"></bb-warning>
		
				<div class="date-time first">
					<bb-datepicker
						(click)="startDatepickerClicked($event)"
						[minDate]="minDate"
						[maxDate]="endDate"
						[rangeStartDate]="startDate"
						[rangeEndDate]="endDate"
						[theme]="theme"
						[label]="'FROM' | translate"
						[active]="preset && preset === 'custom'"
						#startDatePicker
						[ngClass]="{'corrected': datesCorrected}"
						[initialDate]="initialStartDate"
						[(ngModel)]="startDate"
						(ngModelChange)="dateChanged(false, true)">
					</bb-datepicker>
					<bb-time *ngIf="time" [(ngModel)]="startDate" [useDate]="true" [theme]="'time'" (ngModelChange)="dateChanged(true)"></bb-time>
				</div>
			</div>
			
			<div class="date">
				<label>{{ 'END_DATE' | translate }}</label>

				<div class="date-time">
					<bb-datepicker
						(click)="endDatepickerClicked($event)"
						[minDate]="startDate"
						[maxDate]="today"
						[rangeStartDate]="startDate"
						[rangeEndDate]="endDate"
						[theme]="theme"
						[label]="'TO' | translate"
						[active]="preset && preset === 'custom'"
						#endDatePicker
						[(ngModel)]="endDate"
						[initialDate]="initialEndDate"
						(ngModelChange)="dateChanged()">
					</bb-datepicker>
					<bb-time *ngIf="time" [(ngModel)]="endDate" [useDate]="true" [theme]="'time'" (ngModelChange)="dateChanged(true)"></bb-time>
				</div>
			</div>
		</div>
		<ng-content select="[footer]"></ng-content>

	</div>
</div>


<mat-form-field class="no-bottom-padding" [hidden]="!useMatFormField" appearance="fill" (clickOutside)="isOpen = false;" [clickOutsideExcludeQueries]="['.bb-date-presets-overlay-panel']" (click)="onPresetFieldClick($event)">
	<mat-label>{{ presetLabel }}</mat-label>
	<mat-date-range-input [formGroup]="dateRange" [min]="minDate" [max]="today">
		<input matStartDate formControlName="start" placeholder="Start date" (change)="onDateInputChange()" #matStartDateInput (keydown.tab)="onStartDateInputTab($event)" (keydown.enter)="onDateInputEnter($event)">
		<input matEndDate formControlName="end" placeholder="End date" (change)="onDateInputChange()" #matEndDateInput (keydown.enter)="onDateInputEnter($event)">
	</mat-date-range-input>
	<button type="button" class="date-icon"
	mat-icon-button matSuffix
	cdkOverlayOrigin #trigger="cdkOverlayOrigin"
	(click)="isOpen = !isOpen">
		<i class="far fa-calendar fa-lg"></i>
	</button>
	<mat-error *ngIf="dateRange.controls.start.hasError('matStartDateInvalid')">Invalid start date</mat-error>
	<mat-error *ngIf="dateRange.controls.end.hasError('matEndDateInvalid')">Invalid end date</mat-error>
</mat-form-field>

<!-- This template displays the panel contents and is connected to the .date-icon button -->
<ng-template
	cdkConnectedOverlay
	[cdkConnectedOverlayOrigin]="trigger"
	[cdkConnectedOverlayOpen]="isOpen"
>
	<div class="panel bb-date-presets-overlay-panel">
		<div class="overlay-contents">
			<div class="scroll-container" *ngIf="!hidePresets">
				<div class="presets" #scrollPresetContainer>
					<div *ngFor="let p of presets"
						class="preset"
						[class.active]="p.value === preset"
						[class.disabled]="p.disabled"
						mat-menu-item
						(click)="setPreset(p.value);"
					>
						<i class="fa fa-check" *ngIf="p.value === preset"></i>
						{{ p.label }}
					</div>
				</div>
			</div>
			<div class="cal-wrapper" [class.with-time-zone-mismatch]="timeZoneMismatch">
				<div class="info-wrapper" *ngIf="timeZoneMismatch">
					<bb-info [chipText]="'TIMEZONE_DIFFERENCE' | translate" icon="warning" [contents]="'Your time-zone ('+ localTimeZoneName +') is different from the one used in the publication settings. Dates will use the publication timezone ('+ pubTimeZoneName +').'"></bb-info>	
				</div>
				<mat-calendar [selected]="selectedRangeValue" (selectedChange)="selectedChange($event)"
				[minDate]="minDate" [maxDate]="today" #rangeCal1></mat-calendar>
				<mat-calendar [selected]="selectedRangeValue" (selectedChange)="selectedChange($event)"
				[minDate]="minDate" [maxDate]="today" #rangeCal2></mat-calendar>
			</div>
		</div>
		<div class="buttons">
			<bb-button theme="light-v2" class="close-button" (click)="isOpen = false;">{{ 'CLOSE' | translate }}</bb-button>
		</div>
	</div>
</ng-template>
